import { action } from 'typesafe-actions';
import { STORE_TYPES, StoreContextState } from './types';

export const getStoreData = (stores: StoreContextState) =>
  action(STORE_TYPES.GET_STORE_DATA, stores);
